<div class="flx-modal" role="dialog" aria-modal="true" *ngIf="translate">
    <!-- header -->
    <div class="flx-modal__header">
        <h2>Available Statuses</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()" tooltipPosition="left">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Add new statuses if required by entering the name, code, and color code. <span
                class="font-semiBold">Note&colon;&nbsp;</span>Newly created statuses will be visible but not set as<span
                class="font-semiBold">&nbsp;available&nbsp;</span>for other job order types.</h3>
    </div>
    <div class="flx-modal__body">
        <span class="hint">Add Status</span>
        <form [formGroup]="statusForm">
            <div class="field-wrapper-w-btn">
                <div class="status-field">
                    <label class="field-label ">Label</label>
                    <div class="field-row field-row--auto">
                        <input type="text" pInputText formControlName="label" (keyup)="onLabelChange()">
                        <div class="p-error text-10" style="margin-top: -0.8rem" *ngIf="statusForm.controls['label'].touched && statusForm.controls['label'].invalid">
                            {{translate?.general.validationFE.requiredField}}
                        </div>
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label ">Customer Portal Label</label>
                    <div class="field-row field-row--auto">
                        <input type="text" pInputText formControlName="customerPortalLabel">
                        <div class="p-error text-10" style="margin-top: -0.8rem" *ngIf="statusForm.controls['customerPortalLabel'].touched && statusForm.controls['customerPortalLabel'].invalid">
                            {{translate?.general.validationFE.requiredField}}
                        </div>
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label ">Code</label>
                    <div class="field-row field-row--auto">
                        <input type="text" pInputText formControlName="code" [readonly]="true">
                        <div class="p-error text-10" style="margin-top: -0.8rem" *ngIf="statusForm.controls['code'].touched && statusForm.controls['code'].invalid">
                            {{translate?.general.validationFE.requiredField}}
                        </div>
                    </div>
                </div>
                <div class="status-field">
                    <label class="field-label ">Color Code</label>
                    <div class="field-row field-row--auto_colorpick">
                        <input pInputText placeholder="#FFFFFF" class="w-100" [readonly]="true" formControlName="colorInput"/>
                        <div class="w-30px">
                            <p-colorPicker formControlName="color" (onChange)="onColorPickerChange($event)"></p-colorPicker>
                        </div>
                    </div>
                    <div class="p-error text-10" style="margin-top: -0.3rem" *ngIf="statusForm.controls['colorInput'].touched && statusForm.controls['colorInput'].invalid">
                        {{translate?.general.validationFE.requiredField}}
                    </div>
                </div>
                <div class="text-end">
                    <p-button label="Add Status" icon="fa-regular fa-plus" styleClass="h-32" (onClick)="onStatusAdd()"></p-button>
                </div>
            </div>
        </form>
    </div>

    <div class="flx-modal__subheader">
        <h3>Drag the status handles to reorder them. Toggle statuses as<span class="font-semiBold">&nbsp;"Available"&nbsp;</span>to include them for this job order type. Choose a unique color for statuses and set one status as the default value for this type. </h3>
    </div>
    <div class="flx-modal__body">
        <!-- COLOR TABLE -->
        <div class="avs-table">
            <!-- header -->
            <div class="avs-head">
                <div class="avs-head__label">&nbsp;</div>
                <div class="avs-head__label">Label</div>
                <div class="avs-head__label">Portal Label</div>
                <div class="avs-head__label">Code</div>
                <div class="avs-head__label">Color</div>
                <div class="avs-head__default">Default</div>
                <div class="avs-head__active">Available</div>
                <div class="avs-head__active">Actions</div>
            </div>

            <!-- body -->
            <div class="avs-body">
                <!-- Row 1 -->
                <div class="avs-row" *ngFor="let status of statusList">
                    <button class="avs-row__handle" type="button" aria-label="Reorder">
                        <i class="fa-solid fa-grip-vertical"></i>
                    </button>

                    <div class="avs-row__label">
                        <span class="avs-label-pill">{{status.label}}</span>
                    </div>
                    <div class="avs-row__label">
                        <span class="avs-label-pill">{{status.customerPortalLabel}}</span>
                    </div>
                    <div class="avs-row__label">
                        <span class="avs-label-pill">{{status.name}}</span>
                    </div>
                    <div class="avs-row__label_color">
                        <span class="avs-label-pill">{{status.color ? status.color : '#ffffff'}}</span>
                        <p-colorPicker [(ngModel)]="status.color" styleClass="w-30px show-hide-btn-disabled" appendTo="body"></p-colorPicker>
                    </div>

                    <div class="avs-row__default">
                        <p-checkbox [binary]="true"></p-checkbox>
                    </div>

                    <div class="avs-row__active">
                        <p-inputSwitch [ngModel]="true"></p-inputSwitch>
                    </div>
                    <div class="avs-row__active">
                        <i class="fa-regular fa-trash hvr-del"></i>
                    </div>
                </div>

                <!-- Inactive Row -->
                <!-- <div class="avs-row avs-row--inactive">
                    <button class="avs-row__handle" type="button" aria-label="Reorder">
                        <i class="fa-solid fa-grip-vertical"></i>
                    </button>

                    <div class="avs-row__label">
                        <span class="avs-label-pill">Pending</span>
                    </div>
                    <div class="avs-row__label">
                        <span class="avs-label-pill">Pending</span>
                    </div>
                    <div class="avs-row__label">
                        <span class="avs-label-pill">PENDING</span>
                    </div>
                    <div class="avs-row__label_color">
                        <span class="avs-label-pill">#BDBDBDB</span>
                        <p-colorPicker [(ngModel)]="color" styleClass="w-30px" appendTo="body"></p-colorPicker>
                    </div>

                    <div class="avs-row__default">
                        <p-checkbox [binary]="true"></p-checkbox>
                    </div>

                    <div class="avs-row__active">
                        <p-inputSwitch [ngModel]="true"></p-inputSwitch>
                    </div>
                    <div class="avs-row__active">
                        <i class="fa-regular fa-trash hvr-del"></i>
                    </div>
                </div> -->

            </div>
        </div>

    </div>
    <!-- footer -->
    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white"
            (click)="modalRef.hide()">{{translate?.general.buttons.close.singular}}</button>
        <p-button styleClass="h-32" [label]="translate?.general.buttons.save.singular"></p-button>
    </div>
</div>